(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const height = this.header ? this.header.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const rect = this.header ? this.header.getBoundingClientRect() : { top: 0, bottom: 60 };
      this.headerBounds = {
        top: window.pageYOffset + rect.top,
        bottom: window.pageYOffset + rect.bottom || 60,
      };

      let observer = new IntersectionObserver((entries, observer) => {
        if (entries[0] && entries[0].boundingClientRect && entries[0].boundingClientRect.bottom > 0) {
          const bRect = entries[0].boundingClientRect;
          this.headerBounds = {
            top: window.pageYOffset + bRect.top,
            bottom: window.pageYOffset + bRect.bottom,
          };
        }
        observer.disconnect();
      });

      if (this.header) observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const headerBottom =
        this.headerBounds && this.headerBounds.bottom
          ? this.headerBounds.bottom
          : this.header
          ? this.header.offsetHeight
          : 60;
      const headerTop = this.headerBounds && typeof this.headerBounds.top === 'number' ? this.headerBounds.top : 0;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= headerTop) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Hover to open menu */
  document.addEventListener('DOMContentLoaded', () => {
    const headerWrapper = document.querySelector('.header-wrapper');
    const megaTriggers = headerWrapper ? headerWrapper.getAttribute('data-mega-triggers') || '' : '';
    const triggersArray = megaTriggers
      .split(',')
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean);

    const headerMenus = document.querySelectorAll('header-menu details');
    headerMenus.forEach((details) => {
      /* HYBRID MENU: Detect which ones should be Mega vs Dropdown */
      const summaryEl = details.querySelector('summary');
      const spanEl = summaryEl?.querySelector('span') || summaryEl;
      const summaryText = (spanEl?.innerText || spanEl?.textContent || '').trim().toLowerCase();

      let isDropdown = false;
      if (triggersArray.length > 0) {
        // If user specified triggers, make it a dropdown if it's NOT in the trigger list
        const isMega = triggersArray.some((t) => summaryText.includes(t) || t.includes(summaryText));
        if (!isMega) {
          isDropdown = true;
        }
      } else {
        // Fallback: if no triggers specified, use the old 2-level detection
        if (!details.querySelector('ul ul')) {
          isDropdown = true;
        }
      }

      if (isDropdown) {
        const headerMenu = details.closest('header-menu');
        if (headerMenu) headerMenu.classList.add('is-dropdown-menu');
        const content = details.querySelector('.mega-menu__content');
        if (content) content.classList.add('is-dropdown-content');
      }

      details.addEventListener('mouseover', function () {
        if (window.innerWidth >= 990) {
          this.setAttribute('open', '');
          const summary = this.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      });
      details.addEventListener('mouseleave', function () {
        if (window.innerWidth >= 990) {
          this.removeAttribute('open');
          const summary = this.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      });

      /* Click to navigate on desktop */
      if (summaryEl) {
        summaryEl.style.cursor = 'pointer';
        summaryEl.addEventListener('click', function (e) {
          if (window.innerWidth >= 990) {
            const linkUrl = window.shopMenuLinks && window.shopMenuLinks[summaryText];
            if (linkUrl && linkUrl !== '#' && linkUrl !== '') {
              e.preventDefault();
              window.location.href = linkUrl;
            }
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
